import React, { Component } from 'react';
import { Button, Col, Form, Input, Row, Select } from 'antd';
import moment from 'moment-timezone';
const Option = Select.Option;

class ProfileFormComponent extends Component {
    handleSubmit(e) {
        e.preventDefault();
        const { form, onSubmit } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 }
            }
        };

        return (
            <Form onSubmit={this.handleSubmit.bind(this)}>
                <Row gutter={24}>
                    <Col md={24}>
                        <Form.Item label="Profile Name" {...formItemLayout} required={true}>
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input />)}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label="Timezone" {...formItemLayout}>
                            {getFieldDecorator('timezone', {
                                initialValue: 'UTC'
                            })(
                                <Select showSearch>
                                    {moment.tz.names().map(value => {
                                        return (
                                            <Option key={value} value={value}>
                                                {value}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label="Theme" {...formItemLayout}>
                            {getFieldDecorator('theme', {
                                initialValue: 'dark-theme'
                            })(
                                <Select showSearch>
                                    <Option value="dark-theme">Dark</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col style={{ textAlign: 'right' }} md={24}>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export const ProfileForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });

        return data;
    }
})(ProfileFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Settings/ProfileForm.js